import { formatAmount, priceAriaLabel } from "@/lib/currency";

/**
 * An amount plus its ISO currency code, e.g. "$150 USD". The code reads as a
 * label (small, uppercase, muted, letter-spaced) rather than a second
 * number, and is aria-hidden — the whole thing announces as "150 US dollars".
 */
export function PriceTag({ cents, currency }: { cents: number; currency: string }) {
  return (
    <span aria-label={priceAriaLabel(cents, currency)}>
      {formatAmount(cents)}
      <span
        aria-hidden="true"
        className="text-[0.68em] font-bold uppercase tracking-[0.08em] text-muted-foreground"
      >
        {" "}
        {currency}
      </span>
    </span>
  );
}
